export enum ActivityStatus {
    CREATION = 0, 
    ACTION_RELEASE = 1, 
    ACTIVITY_RELEASE = 2
}